import axios from 'axios'
import store from '@/store'
import { ElMessage, ElLoading } from 'element-plus'

export default function download(config, { type = 'application/vnd.ms-excel;charset=UTF-8', fileType = '.zip', fileName = '', exportTypr = '导出', declarationType = '' } = {}) {
  const loading = ElLoading.service({
    lock: true,
    text: '请稍等...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  return new Promise(resolve => {
    axios({
      ...config, baseURL: process.env.VUE_APP_BASE_API, headers: {
        Authorization: store.getters.token
      }, responseType: 'blob'
    }).then((response) => {
      loading.close()
      const res = response.data

      if (res.type === 'application/json') {
        const reader = new FileReader()
        reader.onload = function(event) {
          const dit = JSON.parse(reader.result)
          ElMessage({ message: dit.message, grouping: true })
          loading.close()
          if (dit.code === 401) {
            store.dispatch('user/LOGOUT').then(() => {
              location.reload()
            })
          }
        }
        reader.readAsText(res)
      } else {
        const blob = new Blob([res], { type })
        if (fileName === undefined || fileName === '') {
          const nameFront = declarationType ? `Cat ${declarationType} ` : ''
          fileName = `${nameFront}declaration-${new Date().format('MMdd-hhmm')}`
        }
        if (window.navigator.msSaveBlob) {	// IE以及IE内核的浏览器
          try {
            console.log('fileType:', fileType)
            // window.navigator.msSaveBlob(blob, fileName)	// response为接口返回数据，这里请求的时候已经处理了，如果没处理需要在此之前自行处理var data = new Blob([response.data]) 注意这里需要是数组形式的,fileNm就是下载之后的文件名
            window.navigator.msSaveOrOpenBlob(blob, fileName + fileType)	// 此方法类似上面的方法，区别可自行百度
          } catch (e) {
            console.log(e)
          }
        } else {
          const href = URL.createObjectURL(blob)
          const downloadElement = document.createElement('a')
          downloadElement.href = href
          downloadElement.download = fileName + fileType
          document.body.appendChild(downloadElement)
          downloadElement.click()
          URL.revokeObjectURL(downloadElement.href)
          document.body.removeChild(downloadElement)
        }
        ElMessage({ message: exportTypr + '成功', grouping: true })
        resolve(response)
      }
    }).catch((e) => {
      ElMessage({ message: '下载超时，请减少勾选报关单数量后再尝试下载', grouping: true })
      loading.close()
    })
  })
}
